import { createSelector } from '@reduxjs/toolkit';
import { useGetApprovalParticipationsQuery } from 'features/comments/approvalApi';
import { useUserProfile } from 'hooks/useUserProfile';

const findApprovalParticipation = createSelector(
    (res) => (res.currentData ? res.currentData['hydra:member'] : undefined),
    (_data, blockId) => blockId,
    /**
     * @param {import('models/approval.models').ApprovalParticipation[]} data
     * @param {number} blockId
     */
    (data, blockId) => {
        if (!data) {
            return undefined;
        }

        const approvalParticipations = data.filter((item) => item.target.externalId === `${blockId}`);

        return approvalParticipations.length > 0 ? approvalParticipations[0] : undefined;
    },
);

/**
 * @param {number} blockId
 * @param {number} [areaId]
 *
 * @return {import('models/approval.models').ApprovalParticipation | undefined}
 */
export function useGetBlockApprovalParticipation(blockId, areaId) {
    const userProfile = useUserProfile();

    const { approvalParticipation } = useGetApprovalParticipationsQuery(
        {
            userId: userProfile.userId,
            action: 'none',
            'approvalItem.state': 'pending',
            'approvalItem.target.parent.externalId': `${areaId}`,
            'approvalItem.target.parent.type': 'area',
        },
        {
            selectFromResult: (result) => ({
                ...result,
                approvalParticipation: findApprovalParticipation(result, blockId),
            }),
            skip: areaId === undefined,
        },
    );

    return approvalParticipation;
}
